
//* Realiza el proceso de guardar la solicitud de factura con todo y su detalle por medio de cib-store
export const requestInvoice = async(props) => {
    
    const url = 'https://cib-store.vercel.app/api/request/invoice';

    try {
        const rawResponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(props),
        });
        
        const content = await rawResponse.json();
        console.log('--- Response from cib-store', content);

        return { exito: 1, mensaje: "Solicitud de factura enviada"};

    } catch (error) {
        console.log({ error });

        return { exito: 0, mensaje: `Error ${ error }`};
    }
}